/* jshint esversion: 6 */
/* jshint esversion: 8 */
/* jshint esversion: 11 */
/* jshint ignore:start */
import axios from 'axios';
import { useContext, useEffect, useRef, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { MyContext } from '../../Context/MyProvider';
import Loading from '../Loading';
import ImageLoad from '../ImageLoad';
import { useTranslation } from 'react-i18next';
import secureLocalStorage from 'react-secure-storage';

const DoctorsVideo = () => {
    const { t } = useTranslation();
    const { ApiBaseUrl, ImgBaseUrl } = useContext(MyContext);

    const [loading, setLoading] = useState(true);
    const [filter, setFilter] = useState("");
    const [allData, setAllData] = useState([]);
    const [search, setSearch] = useState("");
    const [departmentList, setDepartmentList] = useState([]);

    const HomeRef = useRef(false);
    const navigate = useNavigate();
    const Location = useLocation();
    const IsType = Location.pathname.startsWith("/video-consultation-doctors");

    const site_currency = secureLocalStorage.getItem("currency");
    const currency = site_currency ? site_currency : "$";

    const filteredData = allData
        .filter(item => !filter || item.name === filter)
        .map(item => ({
            ...item,
            doctors: item.doctors.filter(doc =>
                doc.title?.toLowerCase().includes(search.toLowerCase())
            )
        }))
        .filter(item => item.doctors.length > 0);

    useEffect(() => {
        navigator.geolocation.getCurrentPosition(
            position => {
                const lat = position.coords.latitude;
                const lng = position.coords.longitude;
                fetchHomeData(lat, lng);
            },
            error => {
                // Fallback to default coordinates if geolocation fails
                fetchHomeData(21.215814, 72.828308);
            }
        );
    }, []);

    const fetchHomeData = (lat, long) => {
        if (HomeRef.current) return;
        HomeRef.current = true;
        const Userid = secureLocalStorage.getItem("Userid") || "0";
        axios.post(`${ApiBaseUrl}/customer/home`, { id: Userid, lat: lat, lon: long })
            .then((res) => {
                const { ResponseCode, department_list } = res.data;
                if (ResponseCode === 200) {
                    setDepartmentList(department_list);
                    handleGetDepartmentDoc(department_list, lat, long);
                }
            })
            .catch((error) => {
                console.error("Home Api", error);
                setLoading(false);
            });
    };

    const handleGetDepartmentDoc = async (department_list, lat, lon) => {
        try {
            const Url = IsType ? "/customer/dep_type_video_doctor" : "/customer/dep_type_client_doctor";
            const Type = IsType ? "video_consult" : "clinic_visit";

            const AllData = await Promise.all(department_list.map(async (dep) => {
                const res = await axios.post(
                    `${ApiBaseUrl + Url}`,
                    {
                        department_id: dep.id,
                        lat,
                        lon,
                        page: 1
                    }
                );
                return { name: dep.name, id: dep.id, doctors: res.data[Type] || [] };
            }));
            setAllData(AllData);
        } catch (error) {
            console.error(error);
        }
        setLoading(false);
    };

    const NavigateHandle = (title, Id, departmentid) => {
        navigate(`/doctor-profile/${departmentid}/${Id}`);
        const pagename = IsType ? "Find Your Doctor" : "Book Clinic Visit";
        sessionStorage.setItem("Docprofile", JSON.stringify({ title: title, path: Location.pathname, pagename }));
    };

    if (loading) {
        return <Loading CustomeStyle="fixed left-0 top-0 h-[100vh] w-full flex items-center justify-center bg-white z-[9999]" />;
    }

    return (
        <div className="w-full width-container content-wrapper details px-4 sm:px-6 py-6 md:py-8 bg-slate-50/20">
            {/* Header Section */}
            <div className="mb-6 md:mb-8">
                <h1 className="text-2xl sm:text-3xl md:text-4xl font-extrabold text-slate-800 tracking-tight mb-2">
                    {IsType ? t("Find Your Doctor") : t("Book Clinic Visit")}
                </h1>
                <p className="text-sm sm:text-base text-slate-500 font-medium">
                    {IsType 
                        ? t("Connect with expert doctors from anywhere, anytime • Available 24/7") 
                        : t("Nearby doctors based on your location")}
                </p>
            </div>

            {/* Responsive Search & Filters Control Panel */}
            <div className="bg-white border border-slate-100 p-4 sm:p-5 mb-8 shadow-sm rounded-2xl flex flex-col sm:flex-row items-stretch sm:items-center gap-4 sm:gap-5 transition-shadow hover:shadow-md duration-300">
                <div className="w-full flex items-center gap-3 border border-slate-200 px-4 py-2 rounded-xl bg-slate-50/50 focus-within:bg-white focus-within:border-indigo-500 focus-within:ring-2 focus-within:ring-indigo-100 transition-all duration-300">
                    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="text-slate-400 shrink-0" aria-hidden="true">
                        <circle cx="11" cy="11" r="8"></circle>
                        <path d="m21 21-4.3"></path>
                    </svg>
                    <input 
                        type="text" 
                        value={search} 
                        onChange={(e) => setSearch(e.target.value)} 
                        className="w-full outline-none text-slate-700 font-medium text-sm placeholder-slate-400 bg-transparent" 
                        placeholder={t("Search doctor...")} 
                    />
                </div>
                <div className="w-full sm:w-[240px] shrink-0">
                    <select 
                        onChange={(e) => setFilter(e.target.value)} 
                        value={filter}
                        className="w-full border border-slate-200 outline-none rounded-xl py-2 px-3 bg-slate-50/50 hover:bg-slate-100/50 focus-within:bg-white focus-within:border-indigo-500 focus-within:ring-2 focus-within:ring-indigo-100 transition-all duration-300 cursor-pointer font-semibold text-slate-600 text-sm"
                    >
                        <option value="">{t("All Departments")}</option>
                        {departmentList.map((item, index) => (
                            <option key={index} value={item.name}>{item.name}</option>
                        ))}
                    </select>
                </div>
            </div>

            {/* Departments & Doctors Grid */}
            <div className="space-y-10">
                {filteredData.length >= 1 ? (
                    filteredData.map((item, index) => (
                        <div key={index} className="space-y-4">
                            {/* Department Heading Header bar */}
                            <div className="flex items-center gap-3">
                                <div className="h-1.5 w-8 sm:w-12 bg-indigo-600 rounded-full"></div>
                                <h2 className="text-xl sm:text-2xl font-extrabold text-slate-800 tracking-tight">{item.name}</h2>
                                <div className="flex-1 h-0.5 bg-slate-100 rounded-full"></div>
                                <span className="text-xs font-bold text-indigo-650 bg-indigo-50/60 px-3 py-1 rounded-full border border-indigo-100/20 whitespace-nowrap">
                                    {item.doctors.length} {item.doctors.length === 1 ? t("Doctor") : t("Doctors")}
                                </span>
                            </div>

                            {/* Responsive Grid layout */}
                            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 mt-4">
                                {item.doctors.map((doc, index2) => (
                                    <div 
                                        key={index2} 
                                        onClick={() => NavigateHandle(doc.title, doc.id, item.id)} 
                                        className="rounded-2xl border border-slate-100 bg-white shadow-sm hover:shadow-lg hover:-translate-y-1.5 transition-all duration-300 ease-out group cursor-pointer flex flex-col justify-between overflow-hidden"
                                    >
                                        <div className="p-5 flex flex-col justify-between flex-1 gap-5">
                                            <div className="flex items-start gap-4">
                                                {/* Doctor Profile Picture */}
                                                <div className="relative w-16 h-16 rounded-full overflow-hidden shrink-0 border border-slate-100 shadow-inner bg-slate-50 group-hover:border-indigo-200 transition-colors duration-300">
                                                    <ImageLoad 
                                                        src={ImgBaseUrl + doc.logo} 
                                                        CustomeStyle="w-full h-full object-cover" 
                                                        alt={doc.zone_name} 
                                                    />
                                                </div>
                                                
                                                {/* Doctor details */}
                                                <div className="flex-1 min-w-0">
                                                    <span className="inline-block text-[10px] font-bold text-indigo-600 bg-indigo-50 px-2 py-0.5 rounded-lg border border-indigo-100/10 mb-1">
                                                        {doc.title}
                                                    </span>
                                                    <h3 className="text-base font-extrabold text-slate-800 leading-snug group-hover:text-indigo-600 transition-colors duration-300 truncate mb-1">
                                                        {doc.zone_name}
                                                    </h3>
                                                    <p className="text-xs text-slate-400 font-medium line-clamp-2 leading-relaxed mb-1">
                                                        {doc.subtitle}
                                                    </p>
                                                </div>
                                            </div>

                                            {/* Rating and Info Details */}
                                            <div className="pt-4 border-t border-slate-50 flex items-center justify-between text-xs text-slate-500 font-semibold gap-3 flex-wrap">
                                                {doc.avg_star !== 0 ? (
                                                    <div className="flex items-center gap-1 bg-amber-50 text-amber-700 px-2 py-0.5 rounded-lg border border-amber-100/30">
                                                        <svg xmlns="http://www.w3.org/2000/svg" width="13" height="13" viewBox="0 0 24 24" fill="currentColor" className="text-amber-500 shrink-0">
                                                            <path d="M12 17.27L18.18 21l-1.64-7.03L22 9.24l-7.19-.61L12 2 9.19 8.63 2 9.24l5.46 4.73L5.82 21z"></path>
                                                        </svg>
                                                        <span>{doc.avg_star}</span>
                                                        <span className="text-amber-600/60 font-normal">({doc.tot_review})</span>
                                                    </div>
                                                ) : (
                                                    <div className="flex items-center gap-1 text-slate-400">
                                                        <svg xmlns="http://www.w3.org/2000/svg" width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="shrink-0">
                                                            <polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2"></polygon>
                                                        </svg>
                                                        <span className="font-medium text-slate-400">{t("No reviews")}</span>
                                                    </div>
                                                )}

                                                <div className="flex items-center gap-1 text-slate-500">
                                                    <svg xmlns="http://www.w3.org/2000/svg" width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="text-slate-400 shrink-0">
                                                        <circle cx="12" cy="8" r="7"></circle>
                                                        <polyline points="8.21 13.89 7 23 12 20 17 23 15.79 13.88"></polyline>
                                                    </svg>
                                                    <span>{doc.year_of_experience} {t("years exp")}</span>
                                                </div>
                                            </div>

                                            {/* Price / Channel and CTA Button */}
                                            <div className="pt-4 border-t border-slate-50 flex items-center justify-between gap-4 mt-1">
                                                <div className="flex flex-col">
                                                    <span className="text-[10px] text-slate-400 font-bold uppercase tracking-wider">{IsType ? t("Video Consult") : t("Clinic Visit")}</span>
                                                    <span className="font-extrabold text-slate-800 text-sm mt-0.5">
                                                        {IsType 
                                                            ? `${currency}${doc.min_vid_price} - ${currency}${doc.max_vid_price}` 
                                                            : `${currency}${doc.min_inp_price} - ${currency}${doc.max_inp_price}`}
                                                    </span>
                                                </div>
                                                <button className="px-4 py-2 bg-indigo-600 hover:bg-indigo-700 text-white font-bold text-xs rounded-xl shadow-sm hover:shadow-md transition-all duration-300 focus:outline-none focus:ring-2 focus:ring-indigo-100 group-hover:scale-102">
                                                    {t("Book")}
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                ))}
                            </div>
                        </div>
                    ))
                ) : (
                    <div className="text-center py-16 bg-white border border-slate-100 rounded-3xl p-8 shadow-sm">
                        <svg xmlns="http://www.w3.org/2000/svg" width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" className="text-slate-300 mx-auto mb-3">
                            <circle cx="12" cy="12" r="10"></circle>
                            <line x1="8" y1="12" x2="16" y2="12"></line>
                        </svg>
                        <h3 className="text-lg font-bold text-slate-850 mb-1">{t("No doctors found")}</h3>
                        <p className="text-slate-400 text-sm font-medium">{t("Try adjusting your search filters")}</p>
                    </div>
                )}
            </div>
        </div>
    );
};

export default DoctorsVideo;
/* jshint ignore:end */